import { ReactNode } from 'react'
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material'
import { theme as defaultTheme } from './theme-defaults'

export const ThemeProvider = (props: { children: ReactNode }): JSX.Element => {
  const theme = createTheme(defaultTheme as any)

  return (
    <MuiThemeProvider theme={theme}>
      {props.children}
    </MuiThemeProvider>
  )
}
